import { GridValueGetterParams } from '@mui/x-data-grid-pro'
import { useCallback } from 'react'
import { useFormatRecurrence } from '@/hooks'

export function useGetRecurrenceValue() {
  const formatRecurrence = useFormatRecurrence()

  return useCallback(
    (params: GridValueGetterParams) => {
      const fieldName = params.field.replace('formattedData.', '')
      const recurrence = params.row[fieldName]

      if (!recurrence) return '-'
      return formatRecurrence(recurrence)
    },
    [formatRecurrence],
  )
}
